import React from 'react'
import { Outlet } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'

const ProtectedRoutesByMaintenance = () => {
  const flags = useFlags()

  if (flags.maintenance) return <Navigate to="/maintenance" />

  return <Outlet />
}

export default ProtectedRoutesByMaintenance
